import Netx from '@netx/core/bootstrap';

export const getUniqueBrandPortalSlugFromLabel = (
	id?: number,
	label?: string,
) => {
	if (!label) return '';

	// trim and make everything lowercase
	// convert pattersn of multiple dashes or non-word characters -> a single dash
	label = label
		.trim()
		.toLowerCase()
		.replace(/[-\W]+/g, '-');

	// TODO: we need to be looking up the data and not assume there will always be a global
	// collection... because there wont always be (:pray:)
	// especially since we do not have any websockets hooked up and this is stale data from
	// the moment we fetch it
	// We should probably get an auto lookup for portal slugs and create a custom validator
	// so we validate on keystroke and force them to pick a unique slug and not just slam
	// a -<number> onto it
	const isUnique = (value: string) =>
		// Is there a model other than this one with the same slug already?
		// (We specifically exclude our own model's ID.)
		!(Netx as any).system?.portals?.find(
			(m: any) => m.id != id && m.get('path') === value,
		);

	// If we have a collection, search it for duplicate slugs.
	if (!isUnique(label)) {
		let index = 2;
		// Keep incrementing & searching until we can't find this modified slug in our collection.
		while (!isUnique(`${label}-${index}`)) index++;
		label += `-${index}`;
	}

	return label;
};
